import { useContext, useEffect, useState } from 'react';
import apiUnidade from '../../../../services/apis/apiUnidade';
import { ToastContext } from '../../../../contexts/ToastContext';
import {
	AlertDialogAction,
	AlertDialogCancel,
	AlertDialogContent,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogTitle,
	AlertDialogTrigger,
} from '../../../../components/ui/alert-dialog';
import {
	Dialog,
	DialogClose,
	DialogContent,
	DialogDescription,
	DialogFooter,
	DialogHeader,
	DialogTitle,
	DialogTrigger,
} from '../../../../components/ui/dialog';
import apiEmpresa from '../../../../services/apis/apiEmpresa';
import { useParams } from 'react-router-dom';
import apiGrupo from '../../../../services/apis/apiGrupo';
import PaginationBar from '../../../../components/common/PaginationBar';
import getParent, {getParentMap} from '../../../../funcs/getParent';
import apiEnum from '../../../../services/apis/apiEnum';

export default function ListaUnidade({
	atualizarLista,
	pesquisar,
	funcaoModalController,
	onClose
}) {
	const [listaUnidade, setListaUnidade] = useState([]);
	const [tiposUnidade, setTiposUnidade] = useState([]);
	const [idEditar, setIdEditar] = useState();
	const [nome, setNome] = useState('');
	const [diasDeTrabalhoMes, setDiasDeTrabalhoMes] = useState(0);
	const [horasTrabalhadasDia, setHorasTrabalhadasDia] = useState(0);
	const [tensao, setTensao] = useState(0);
	const [fatorPotencia, setFatorPotencia] = useState(0);
	const [listaGrupo, setListaGrupo] = useState([]);
	const [empresaId, setEmpresaId] = useState(0);
	const [grupoId, setGrupoId] = useState();
	const [pagination, setPagination] = useState();
	const [tipoUnidade, setTipoUnidade] = useState('');
	const [listaEmpresa, setListaEmpresa] = useState([]);
	const [listaEmpresaTabela, setListaEmpresaTabela] = useState(new Map());
	const [itemRemovido, setItemRemovido] = useState();
	const [idRemover, setIdRemover] = useState();
	const { erro, sucesso } = useContext(ToastContext);
	const { page } = useParams();
	const funcaoModal = funcaoModalController.funcaoModal;
	
	useEffect(() => {
		apiGrupo.fetchApi().then(res => {
			setListaGrupo(res.data);
		});
		
		apiUnidade.fetchApi(page).then((res) => {
			setListaUnidade(res.data.items);
			setPagination(res.data);
		});
	}, [page]);

	useEffect(() => {
		grupoId &&
		apiEmpresa.getByGrupoApi(grupoId).then(res => {
			setListaEmpresa(res.data);
		}).catch(error => {

		});
	}, [grupoId]);

	useEffect(() => {
		const fetchEmpresas = async () => {
			if (!listaUnidade || listaUnidade.length === 0) return;

			const empresaPromises = listaUnidade.map(unidade =>
				apiEmpresa.getById(unidade.empresaId)
			);

			const empresas = await Promise.all(empresaPromises);

			const empresasMap = new Map(
				empresas.map(empresa => [empresa.data.id, empresa.data])
			);

			setListaEmpresaTabela(empresasMap);
		};

		fetchEmpresas();
	}, [listaUnidade]);

	//DELETE UNIDADE
	function deletar(id) {
		apiUnidade
			.deleteApi(id)
			.then((res) => {
				atualizarLista();
				sucesso('Unidade deletada com sucesso!');
			})
			.catch((error) => {
				console.error(error.message);
				erro('Erro ao deletar unidade');
			});
	}
	
	function limparInputs() {
		setNome('');
		setDiasDeTrabalhoMes('');
		setHorasTrabalhadasDia('');
		document.getElementById('empresaId').value = 0;
	}

	function enviar(e) {
		e.preventDefault();
		const unidade = {
			nome: e.target.nome.value,
			empresaId: e.target.empresaId.value,
			tipoUnidade: e.target.tipoUnidade.value,
			diasDeTrabalhoMes: diasDeTrabalhoMes,
			horasTrabalhadasDia: horasTrabalhadasDia,
			fatorPotencia: parseFloat(fatorPotencia),
			tensao: parseFloat(tensao),
		};
		if (funcaoModal === 'Adicionar') {
			apiUnidade
				.postApi(unidade)
				.then((res) => {
					atualizarLista();
					limparInputs();
					sucesso('Unidade adicionada com sucesso!');
					onClose();
				})
				.catch((error) => {
					console.error(error.message);
					erro('Erro ao adicionar unidade');
				});
			} else if (funcaoModal === 'Editar') {
				apiUnidade
				.putApi(idEditar, unidade)
				.then((res) => {
					atualizarLista();
					sucesso('Unidade editada com sucesso!');
					onClose();
				})
				.catch((error) => {
					erro('Erro ao editar unidade!');
					console.error(error.message);
				});
		}
	}

	return (
		<>
			<Dialog>
				<div className="w-full flex flex-col items-center mt-[40px] md:px-[200px]">
					<table className="w-full">
						<thead className="border-b w-full">
							<tr>
								<th className="text-[25px] pl-[10px] text-center">
									ID
								</th>
								<th className="text-[25px] pl-[10px] text-start">
									Nome
								</th>
								<th className="text-[25px] pl-[10px] text-start">
									Empresa
								</th>
							</tr>
						</thead>
						<tbody>
							{listaUnidade.map(
								(unidade, i) =>
									unidade.nome
										.toUpperCase()
										.startsWith(
											pesquisar.toUpperCase()
										) && (
										<tr
											className="border-b hover:bg-gray-200 hover:bg-opacity-5"
											key={i}
										>
											<td className="pl-[10px] text-[20px] text-center">
												{
													unidade.id
												}
											</td>
											<td className="pl-[10px] text-[20px]">
												{
													unidade.nome
												}
											</td>
											<td className="flex justify-between py-1">
												<span className="text-[20px] pl-[10px]">
													{getParentMap(listaEmpresaTabela, unidade.empresaId)?.nome}
												</span>
												<span className="flex">
													<AlertDialogTrigger>
														<div
															onClick={() => {
																const parent = getParentMap(listaEmpresaTabela, unidade.empresaId);
																const grupo = getParent  (listaGrupo, parent.grupoId);
																
																setIdEditar(
																	unidade.id
																);
																setNome(
																	unidade.nome
																);

																setGrupoId(
																	grupo.id
																);
																setEmpresaId(
																	unidade.empresaId
																);
																setTipoUnidade(
																	unidade.tipoUnidade
																);
																setTensao(
																	unidade.tensao
																);
																setDiasDeTrabalhoMes(
																	unidade.diasDeTrabalhoMes
																);
																setHorasTrabalhadasDia(
																	unidade.horasTrabalhadasDia
																);
																setFatorPotencia(
																	unidade.fatorPotencia
																);

																funcaoModalController.setFuncaoModal(
																	'Editar'
																);
															}}
														>
															<i
																className="fa-solid fa-pen-to-square text-[18px] hover:text-lightBlue"
																title="Editar"
															></i>
														</div>
													</AlertDialogTrigger>
													<DialogTrigger>
														<div
															className="mx-2.5"
															onClick={() => {
																setItemRemovido(
																	unidade.nome
																);
																setIdRemover(
																	unidade.id
																);
															}}
														>
															<i
																className="fa-solid fa-trash text-[18px] hover:text-lightBlue"
																title="Deletar"
															></i>
														</div>
													</DialogTrigger>
												</span>
											</td>
										</tr>
									)
							)}
						</tbody>
					</table>
					{
						pagination !== undefined &&
						<PaginationBar pagination={pagination} />
					}
				</div>
				<DialogContent>
					<DialogHeader>
						<DialogTitle>
							Excluir {itemRemovido}?
						</DialogTitle>
					</DialogHeader>
					<DialogDescription>
						Todos os dados associados com {itemRemovido}{' '}
						serão removidos.
					</DialogDescription>
					<DialogFooter>
						<div
							className="bg-red-600/70 py-2 px-4 rounded-md hover:bg-red-600 hover:cursor-pointer border-slate-800 border-2 transition-all duration-200 ease-in-out"
							onClick={() => deletar(idRemover)}
						>
							<DialogClose>Excluir</DialogClose>
						</div>
					</DialogFooter>
				</DialogContent>
			</Dialog>

			<AlertDialogContent>
				<form onSubmit={(e) => enviar(e)}>
					<AlertDialogHeader>
						<AlertDialogTitle>
							{funcaoModal} Unidade
						</AlertDialogTitle>
					</AlertDialogHeader>
					<div className="w-full flex justify-around my-5 px-5 flex-wrap gap-5">
						{/* NOME */}
						<div className="flex flex-col justify-end">
							<label
								htmlFor="nome"
								className="text-[18px] mb-2 pl-1"
							>
								Nome
							</label>
							<input
								id="nome"
								type="text"
								placeholder="nome da unidade"
								className="border-b text-[20px] p-1.5 bg-[#0b101d] rounded-t-md w-[180px]"
								value={nome}
								onChange={(e) =>
									setNome(e.target.value)
								}
								required
							/>
						</div>
						{/* GRUPO */}
						<div className="flex flex-col justify-end">
							<label
								htmlFor="grupoId"
								className="text-[18px] mb-2 pl-1"
							>
								Grupo{' '}
							</label>
							<select
								className="border-b text-[20px] h-[42.8px] bg-[#0b101d] rounded-t-md w-[180px]"
								name="grupoId"
								id="grupoId"
								value={grupoId}
								required
								onChange={(e) =>
									setGrupoId(
											e.target.value
									)
								}
							>
								<option label="   "></option>
								{listaGrupo.map(
									(elemento, i) => (
										<option
											value={
												elemento.id
											}
											key={i}
										>
											{
												elemento.nome
											}
										</option>
									)
								)}
							</select>
						</div>
						{/* EMPRESA */}
						<div className="flex flex-col justify-end">
							<label
								htmlFor="empresaId"
								className="text-[18px] mb-2 pl-1"
							>
								Empresa{' '}
							</label>
							<select
								className="border-b text-[20px] h-[42.8px] bg-[#0b101d] rounded-t-md w-[180px]"
								name="empresaId"
								id="empresaId"
								value={empresaId}
								required
								onChange={(e) =>
									setEmpresaId(
											e.target.value
									)
								}
							>
								<option label="   "></option>
								{listaEmpresa.map(
									(elemento, i) => (
										<option
											value={
												elemento.id
											}
											key={i}
										>
											{
												elemento.nome
											}
										</option>
									)
								)}
							</select>
						</div>
						{/* TIPO UNIDADE */}
						<div className="flex flex-col justify-end">
							<label
								htmlFor="tipoUnidade"
								className="text-[18px] mb-2 pl-1"
							>
								Tipo Unidade
							</label>
							<select
								className="border-b text-[20px] h-[42.8px] bg-[#0b101d] rounded-t-md w-[180px]"
								name="tipoUnidade"
								id="tipoUnidade"
								value={tipoUnidade}
								required
								onChange={(e) =>
									setTipoUnidade(
										e.target.value
									)
								}
							>
								<option label="   "></option>
"								<option value={"Bovino"}>Bovino</option>	
								<option value={"Suíno"}>Suíno</option>	
								<option value={"Aves"}>Aves</option>	
							</select>
						</div>
						
					</div>
					<AlertDialogFooter>
						<div className="flex w-full justify-end gap-x-4 p-4">
							<AlertDialogAction className="w-32">
								Confirmar
							</AlertDialogAction>
							<div onClick={onClose}>
								<AlertDialogCancel className="w-32">
									Cancelar
								</AlertDialogCancel>
							</div>
						</div>
					</AlertDialogFooter>
				</form>
			</AlertDialogContent>
		</>
	);
}
